import { RateAgreementBulkUpsertGuard } from './rate-agreement-bulk-upsert.guard';

export const guards: any[] = [RateAgreementBulkUpsertGuard];

export * from './rate-agreement-bulk-upsert.guard';